<template>
    <grid
        controllers='true' 
        :titles='titles'
        :data='contents'
        current-sort="NUMERO"
        search-key="USUARIO"
    />
</template>
<script>
    import grid from '@/components/grid.vue'
    export default {
        name: 'vwCashFlux',
        components: {
            grid
        },
        data(){
            return{
                titles: ['Numero', 'Data', 'Saldo Inicial', 'Saldo total', 'Devoluções', 'Cancelados', 'Usuário'],
                contents: []
            }
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        methods: {
            getData: function(){
                fetch(server + 'getcashflux?token=' + this.getToken)
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        if(responseJSON.data.length > 0){
                            this.contents = responseJSON.data
                        }
                    })
                    .catch(error => {
                        console.log('Error exception', '=>', error)
                    })
            }
        },
        mounted(){
            this.getData()
        }
    }
</script>
<style scoped>

</style>